import Product from "./DictionaryOfPermission/Product";
import Forecast from "./DictionaryOfPermission/Forecast";
import BOM from "./DictionaryOfPermission/BOM";
import CompareProduct from './DictionaryOfPermission/CompareProduct'
import ProductDetail from './DictionaryOfPermission/ProductDetail';

class AuthAccountLess {

    static register = {
        ...{[Product.register_external.PD_ADD_TO_BOM.slug]: Product.register_external.PD_ADD_TO_BOM},
        ...{[ProductDetail.register_external.PDT_ADD_TO_BOM.slug]: ProductDetail.register_external.PDT_ADD_TO_CART},
        ...{[BOM.register_external.VIEW_BOM.slug]: BOM.register_external.VIEW_BOM},
        ...CompareProduct.register,
        ...Forecast.register
    };

    static avUserInfoName = 'AUTH_ACCOUNT_LESS';

}

export default AuthAccountLess;